// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TextField, { TextFieldPresentationProps } from "@flip/MobiusOverrides/TextField";
import { AccountFormState } from "@flip/Overrides/Widgets/CreateAccount/CreateAccount.form.module";
import { maxLengthAttr, xMask } from "@flip/XDL/Utilities";
import { CreateForm } from "@flip/XDL/Utilities/form";
import { GridContainerProps } from "@insite/mobius/GridContainer/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";

interface OwnProps {
    accountForm?: CreateForm<AccountFormState>;
    formId: string;
}

interface CreateAccountUserFormStyles {
    firstNameGridItem?: GridItemProps;
    lastNameGridItem?: GridItemProps;
    phoneNumberGridItem?: GridItemProps;
    companyNameGridItem?: GridItemProps;
    textField?: TextFieldPresentationProps;
    emailGridItem?: GridItemProps;
    phoneNumberTextField?: TextFieldPresentationProps;
    createAccountTitleGridItem?: GridItemProps;
    gridContainer?: GridContainerProps;
}

const createAccountUserFormStyles: CreateAccountUserFormStyles = {
    firstNameGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    lastNameGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    emailGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    phoneNumberGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    companyNameGridItem: {
        width: [12, 12, 6, 6, 6],
    },
};

const styles = createAccountUserFormStyles;
const CreateAccountShortForm: FC<OwnProps> = ({ accountForm, formId }) => {
    if (!accountForm) {
        return null;
    }

    const { fields, isSubmitted } = accountForm.state;

    return (
        <>
            <GridItem {...styles.firstNameGridItem}>
                <TextField
                    value={fields.firstName.value}
                    onChange={e => accountForm?.onFieldChange(fields.firstName, e.currentTarget.value)}
                    error={isSubmitted && fields.firstName.error}
                    {...fields.firstName.attrs}
                    {...{ formId }}
                />
            </GridItem>
            <GridItem {...styles.lastNameGridItem}>
                <TextField
                    value={fields.lastName.value}
                    onChange={e => accountForm?.onFieldChange(fields.lastName, e.currentTarget.value)}
                    error={isSubmitted && fields.lastName.error}
                    {...fields.lastName.attrs}
                    {...{ formId }}
                />
            </GridItem>
            <GridItem {...styles.emailGridItem}>
                <TextField
                    value={fields.email.value}
                    onChange={e => accountForm?.onFieldChange(fields.email, e.currentTarget.value)}
                    error={isSubmitted && fields.email.error}
                    {...fields.email.attrs}
                    type="email"
                    {...{ formId }}
                />
            </GridItem>
            <GridItem {...styles.phoneNumberGridItem}>
                <TextField
                    value={fields.phoneNumber.value}
                    onChange={e => accountForm?.onFieldChange(fields.phoneNumber, e.currentTarget.value)}
                    error={isSubmitted && fields.phoneNumber.error}
                    {...fields.phoneNumber.attrs}
                    type="phone"
                    {...{ formId }}
                />
            </GridItem>
            <GridItem {...styles.companyNameGridItem}>
                <TextField
                    value={fields.companyName.value}
                    onChange={e => accountForm?.onFieldChange(fields.companyName, e.currentTarget.value)}
                    error={isSubmitted && fields.companyName.error}
                    {...fields.companyName.attrs}
                    type="companyName"
                    {...{ formId }}
                />
            </GridItem>
        </>
    );
};

export default CreateAccountShortForm;
